<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div style="margin: 20px;">
      </div>
      <div class="bannerOperate">
        <el-button @click="handleAdd" type="primary" size="small">新增轮播图</el-button>
        <el-button @click="handleEditTitle" type="primary" size="small">修改标题</el-button>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow">
        </el-pagination>
      </div>
      <div class="bannerTable">
        <el-table
        ref="multipleTable"
        :data="bannerDatas"
        tooltip-effect="dark"
        style="width: 100%"
        border>
        <el-table-column
          prop="id"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          width="160">
        </el-table-column>
        <el-table-column
          prop="imageUrl"
          label="图片"
          width="120">
          <template slot-scope="scope">
           <el-image
             style="width: 100px; height: 100px"
             :src="scope.row.imageUrl"
             :fit="fit">
           </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          :formatter="handleTypeValue"
          width="160">
        </el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          :formatter="handleStatusValue"
          width="120">
        </el-table-column>
        <!-- <el-table-column prop="bannerVos" label="子分类" show-overflow-tooltip align="left">
          <template slot-scope="scope">
            <el-tag
              :key="index"
              v-for="(item,index) in scope.row.bannerVos"
              closable
              :disable-transitions="false"
              @close="handleClose(item)">
              {{item.name}}
            </el-tag>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="insertTime"
          label="创建时间"
          width="180">
        </el-table-column>
        <el-table-column label="操作"
          show-overflow-tooltip>
           <template slot-scope="scope">
            <el-button
             size="mini"
             @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button
             size="mini"
             type="danger"
             @click="handleDelete(scope.$index, scope.row)">删除</el-button>
           </template>
         </el-table-column>
        </el-table>
      </div>
      <el-dialog title="编辑轮播图"
        :visible.sync="editDialogVisible"
        :append-to-body=true
        width="60%"
        :modal=false>
        <el-form label-position="left" label-width="80px" :model="controlData">
          <el-form-item label="标题:">
            <el-input v-model="controlData.title"></el-input>
          </el-form-item>
          <el-form-item label="图片">
            <el-upload
                action=""
                class="upload-demo"
                :http-request="uploadSectionFile"
                :limit="1"
                :file-list="fileList"
                list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
         <el-form-item label="类型">
            <el-radio-group v-model="controlData.type" @change="onChangeType">
              <el-radio label="1">首页Banner</el-radio>
              <el-radio label="2">首页专区</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="类型编号">
            <el-radio-group v-model="controlData.groupNum" v-if="controlData.type == 1">
              <el-radio label="0">老首页 上方</el-radio>
              <el-radio label="1">新首页 上方</el-radio>
              <el-radio label="2">新首页 中上</el-radio>
              <el-radio label="3">新首页 中下</el-radio>
              <el-radio label="4">新首页 下方</el-radio>
              <el-radio label="5">老首页 下方</el-radio>
            </el-radio-group>
            <el-radio-group v-model="controlData.groupNum" v-if="controlData.type == 2">
             <el-radio label="0">老首页</el-radio>
             <el-radio label="1">新首页</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="状态">
             <el-radio-group v-model="controlData.state">
               <el-radio label="1">使用</el-radio>
               <el-radio label="0">未使用</el-radio>
             </el-radio-group>
           </el-form-item>
          <el-form-item label="关联类型">
            <el-radio-group v-model="controlData.infoType" @change="onChangeInfoType">
              <el-radio label="1">门店详情</el-radio>
              <el-radio label="2">商品列表</el-radio>
              <el-radio label="3">商品详情</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="关联门店" v-show="controlData.infoType == 1">
            <el-select v-model="controlData.unionId" style="width: 300px;">
              <el-option
                v-for="item in storeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item>
           <el-form-item label="关联商品" v-show="controlData.infoType == 2">
             <el-select multiple  v-model="controlData.unionIds" style="width: 300px;">
               <el-option
                 v-for="item in productDatas"
                 :key="item.id"
                 :label="item.name"
                 :value="item.id"/>
             </el-select>
           </el-form-item>
          <el-form-item label="关联商品" v-show="controlData.infoType == 3">
            <el-select v-model="controlData.unionId" style="width: 300px;">
              <el-option
                v-for="item in productDatas"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_updateBanner()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加轮播图"
        :visible.sync="addDialogVisible"
        :append-to-body=true
        width="60%"
        :modal=false>
        <el-form label-position="left" label-width="80px" :model="controlData">
          <el-form-item label="标题">
             <el-input v-model="controlData.title"></el-input>
           </el-form-item>
           <el-form-item label="图片">
             <el-upload
                 action=""
                 class="upload-demo"
                 :http-request="uploadSectionFile"
                 :limit="1"
                 :file-list="fileList"
                 list-type="picture">
               <el-button size="small" type="primary">点击上传</el-button>
             </el-upload>
           </el-form-item>
          <el-form-item label="类型">
             <el-radio-group v-model="controlData.type" @change="onChangeType">
               <el-radio label= "1" >首页Banner</el-radio>
               <el-radio label= "2" >首页专区</el-radio>
             </el-radio-group>
           </el-form-item>
          <el-form-item label="类型编号">
            <el-radio-group v-model="controlData.groupNum" v-if="controlData.type == 1">
             <el-radio label="0">老首页 上方</el-radio>
             <el-radio label="1">新首页 上方</el-radio>
             <el-radio label="2">新首页 中上</el-radio>
             <el-radio label="3">新首页 中下</el-radio>
             <el-radio label="4">新首页 下方</el-radio>
             <el-radio label="5">老首页 下方</el-radio>
            </el-radio-group>
            <el-radio-group v-model="controlData.groupNum" v-if="controlData.type == 2">
              <el-radio label="0">老首页</el-radio>
              <el-radio label="1">新首页</el-radio>
            </el-radio-group>
          </el-form-item>
           <el-form-item label="状态">
            <el-radio-group v-model="controlData.state">
              <el-radio label= "1" >使用</el-radio>
              <el-radio label= "0" >未使用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="关联类型" @change="onChangeInfoType">
            <el-radio-group v-model="controlData.infoType">
              <el-radio label="1" >门店详情</el-radio>
              <el-radio label="2" >商品列表</el-radio>
              <el-radio label="3">商品详情</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="关联门店" v-if="controlData.infoType == 1">
            <el-select v-model="controlData.unionId" style="width: 300px;">
              <el-option
                v-for="item in storeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="关联商品" v-if="controlData.infoType == 2">
            <el-select multiple v-model="controlData.unionIds" style="width: 300px;">
              <el-option
                v-for="item in productDatas"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="关联商品" v-if="controlData.infoType == 3">
            <el-select v-model="controlData.unionId" style="width: 300px;">
              <el-option
                v-for="item in productDatas"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_addBanner()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="20%"
        :append-to-body=true
        center>
        <span>确定要删除当前轮播图吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_deleteBanner()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="修改轮播图标题"
        :visible.sync="editTitleDialogVisible"
        :append-to-body=true
        width="40%"
        :modal=false>
        <el-form label-position="left" label-width="80px">
          <el-form-item label="标题1">
             <el-input v-model="bannerTitle[0]"></el-input>
          </el-form-item>
          <el-form-item label="标题2">
             <el-input v-model="bannerTitle[1]"></el-input>
          </el-form-item>
           <el-form-item label="标题3" v-if="bannerTitle.length>2">
              <el-input v-model="bannerTitle[2]"></el-input>
           </el-form-item>
           <el-form-item label="标题4" v-if="bannerTitle.length>3">
              <el-input v-model="bannerTitle[3]"></el-input>
           </el-form-item>
           <el-form-item label="标题5" v-if="bannerTitle.length>4">
              <el-input v-model="bannerTitle[4]"></el-input>
           </el-form-item>
           <el-form-item label="标题6" v-if="bannerTitle.length>5">
              <el-input v-model="bannerTitle[5]"></el-input>
           </el-form-item>
           <el-form-item label="标题7" v-if="bannerTitle.length>6">
              <el-input v-model="bannerTitle[6]"></el-input>
           </el-form-item>
           <el-form-item label="标题8" v-if="bannerTitle.length>7">
              <el-input v-model="bannerTitle[7]"></el-input>
           </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editTitleDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_editBannerTitle()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="20%"
        :append-to-body=true
        center>
        <span>确定要删除当前轮播图吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_deleteBanner()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getStoreList,getBannerSpu,getBanneTitle,editBannerTitle,getBannerStore,getAllBanner, getAllProduct1,addBanner, updateBanner, deleteBanner, uploadFile1} from 'api/request'
import {getDepartment} from 'api/post'
import {ERR_OK} from 'api/config'
import {formatDate, loadingInstance, Success, Error} from 'common/js/util'
export default {
  components: { MSidebar,MHeader },
  data() {
    return {
      supplierId: null,//供应商id
      categoryId: null,//分类id
      keywords: null,
      imageUrl:null,
      productDatas:[],
      fileList:[],
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      keywords: null,
      paginationShow: false,
      detailDialogVisible: false,
      pushDialogVisible: false,
      editDialogVisible: false,
      addDialogVisible: false,
      editTitleDialogVisible: false,
      freezeDialogVisible: false,
      deleteDialogVisible: false,
      controlData: {
      },
      userDetail: [],
      bannerDatas: [],
      cfAdminVos: [],
      bannerTitle:[],//全部标题
      storeList:[],//全部门店
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    }else{
      this._getBannerTitle();
      this._getList();
      this._getProduct();
      this._getStoreList();
    }
  },
  methods: {
    handleClose(item){
      this.deleteDialogVisible = true;
      this.controlData = item;
    },
    handleStatusValue(row, column, cellValue, index) {
      //banner图状态   1.使用  0.未使用
      switch(cellValue){
         case 0:
          return "未使用";
         case 1:
          return "使用";
      }
    },
    handleTypeValue(row, column, cellValue, index) {
      ////专区类型  1.首页Banner    2.首页专区（Banner下的几个圆圈）
      switch(cellValue){
         case 1:
          return "首页Banner";
         case 2:
          return "首页专区";
      }
    },
    //文件类型   101 商品图片 102 供应商营业执照  103 banner图    104商品分类logo
    uploadSectionFile(param){
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 103);
      uploadFile1(form).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.controlData.imageUrl = res.data;
        } else {
          Error(this, res)
        }
      })
    },
    handleChange () {
      console.log(this.status)
    },
    pageChange (val) {
      console.log(val)
      this.pageNum = val
      this.bannerDatas = []
      this._getList()
    },
    handleEditTitle() {
      this.editTitleDialogVisible = true;
    },
    handleAdd() {
      this.addDialogVisible = true;
      this.controlData = {type:'1',groupNum:'1',infoType:'1',state:'1',unionIds:[]};
    },
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.bannerDatas[index];
    },
    handleEdit(index, row) {
      this.editDialogVisible = true;
      this.controlData = {}
      this.controlData = JSON.parse(JSON.stringify(this.bannerDatas[index]));
      this.controlData.state = this.controlData.state+"";
      this.controlData.type = this.controlData.type+"";
      this.controlData.groupNum = this.controlData.groupNum+"";
      this.controlData.infoType = this.controlData.infoType+ "";
      this.fileList = [];
      this.fileList.push({
        name:this.controlData.imageUrl,
        url:this.controlData.imageUrl
      });
      // 请求关联的门店信息
      if(row.infoType === 1){
        loadingInstance(Loading)
        getBannerStore({bannerId:	row.id}).then((res) => {
          loadingInstance(Loading).close()
          if (res.status === ERR_OK) {
            if(res.data && res.data.length > 0){
              this.controlData.unionIds = []
              this.controlData.unionId = res.data[0].id;
              this.$forceUpdate();
            }
          } else {
            Error(this, res)
          }
        })
      }else{
        // 请求关联商品列表
        loadingInstance(Loading)
        getBannerSpu({bannerId:	row.id}).then((res) => {
          loadingInstance(Loading).close()
          if (res.status === ERR_OK) {
            if(res.data && res.data.length > 0){
              this.controlData.unionIds = res.data.map(item=>item.id)
              this.controlData.unionId = res.data[0].id;
            }
          } else {
            Error(this, res)
          }
        })
      }

      console.log('sdfsdf',this.controlData)
    },
    handleShowDetail(row) {
      this.detailDialogVisible = true;s
      this.userDetail = [ row ];
    },
    handleShowPush(row) {
      this.cfAdminVos=row.cfAdminVos;
      this.pushDialogVisible = true;
    },
    _editBannerTitle(){
      loadingInstance(Loading);
      editBannerTitle(this.bannerTitle).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.editTitleDialogVisible = false;
          alter("修改成功！")
        } else {
          Error(this, res);
        }
      })
    },
    _addBanner(){
      if(this.controlData.unionId && (!this.controlData.unionIds || !this.controlData.unionIds.length)) this.controlData.unionIds = [this.controlData.unionId]
      let param = {
        imageUrl: this.controlData.imageUrl,
        state: parseInt(this.controlData.state),
        type: parseInt(this.controlData.type),
        unionIds: this.controlData.unionIds,
        title: this.controlData.title,
        infoType: this.controlData.infoType,
        groupNum: this.controlData.groupNum
      }
      loadingInstance(Loading);
      addBanner(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.addDialogVisible= false;
          this.fileList=[];
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _updateBanner(){
      if(this.controlData.unionId && !this.controlData.unionIds.length) this.controlData.unionIds = [this.controlData.unionId]
      let param = {
        id: this.controlData.id,
        imageUrl: this.controlData.imageUrl,
        state: parseInt(this.controlData.state),
        type: parseInt(this.controlData.type),
        unionIds: this.controlData.unionIds,
        title: this.controlData.title,
        infoType: this.controlData.infoType,
        groupNum: this.controlData.groupNum
      }
      loadingInstance(Loading);
      updateBanner(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.editDialogVisible= false;
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _deleteBanner(){
      let param = {
        id: this.controlData.id
      }
      loadingInstance(Loading);
      deleteBanner(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.deleteDialogVisible=false;
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _getList () {
      let param = {
        keywords: this.keywords,
        current: this.pageNum,
        size: this.pageSize
      }
      loadingInstance(Loading)
      getAllBanner(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.bannerDatas = res.data.records
          this.totalNum = res.data.total
          if(res.data.pages>1){
            this.paginationShow = true;
          }
        } else {
          Error(this, res)
        }
      })
    },
    _getProduct () {
      let param = {
       /*
        brandId:			//品牌id*/
        supplierId: this.supplierId,//供应商id
        categoryId: this.categoryId,//分类id
        content: this.keywords,
        current: this.pageNum,
        size: 10000000,
        homePage:""
      }
      loadingInstance(Loading)
      getAllProduct1(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.productDatas = res.data
        } else {
          Error(this, res)
        }
      })
    },
    // 获取轮播图标题
    _getBannerTitle () {
      console.log(1111111111111111111111111111);
      let param = {}
      loadingInstance(Loading)
      getBanneTitle(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.bannerTitle = res.data
        } else {
          Error(this, res)
        }
      })
    },
    // 获取门店列表
    _getStoreList () {
      loadingInstance(Loading)
      getStoreList().then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.storeList = res.data
        } else {
          Error(this, res)
        }
      })
    },
    // 修改类型
    onChangeType () {
      this.controlData.groupNum = '1'
    },
    // 修改关联类型
    onChangeInfoType () {
      this.controlData.unionIds = []
      this.controlData.unionId = null
      console.log("hxl"+this.controlData.unionIds);
      this.$forceUpdate();
    }
  }
}
</script>
<style scoped>
   .bannerOperate{
     height: 40px;
     margin: 20px;
     box-sizing: border-box;
   }
   .bannerTable{
     padding-left: 20px;
     padding-right: 20px;
     position: relative;
   }
</style>
<style>
  .el-tag + .el-tag {
    margin: 5px;
  }
  .bannerOperate .el-input {
    width:220px;
    height: 40px;
    margin-right: 10px;
    display: inline-block;
    float: left;
  }
  .bannerOperate .el-button {
    width:100px;
    height: 40px;
    display: inline-block;
    float: left;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/system/system.vue